import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 md:py-32 px-4 relative overflow-hidden" data-id="element-121">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-122" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-dark-card border-2 border-gold mb-8 shadow-[0_0_30px_rgba(212,168,67,0.2)]" data-id="element-124">
          <ShieldCheck className="w-12 h-12 text-gold" data-id="element-125" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-heading font-bold text-white mb-8" data-id="element-126">
          Garantía de 7 días
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-lg md:text-xl text-gray-300 mb-12 max-w-2xl mx-auto" data-id="element-127">
          <p data-id="element-128">
            Si el contenido no cumple tus expectativas, solicitás el reembolso
            dentro de los primeros 7 días y te devolvemos el dinero.
          </p>
        </motion.div>
      </div>
    </section>;
}